import {
  useUpdatePointOfInterestMutation,
  SelectedPointOfInterestDocument,
  ReportDetailsDocument,
} from '@/__generated__/graphql';
import { DocumentNode } from 'graphql';

export function usePoiPostInspectionNoteMutation() {
  const [updatePoi, { data, loading, error }] = useUpdatePointOfInterestMutation();

  const updateNote = async (
    postInspectionNote: string | undefined | null,
    pointOfInterestId: string,
    refetchQueries?: DocumentNode[]
  ) => {
    if (!pointOfInterestId) return;
    return updatePoi({
      variables: {
        input: {
          pointOfInterestId,
          postInspectionNote,
          lastModifiedFor: 'Update post inspection note',
        },
      },
      refetchQueries: refetchQueries || [SelectedPointOfInterestDocument, ReportDetailsDocument],
    });
  };

  return { updateNote, data, loading, error };
}
